import React from "react";
import type { Meta, StoryObj } from "@storybook/react";
import VerificationFailed from "../../screens/auth/VerificationFailed";
import { MockedProfileSwitcherManager } from "../../contexts/ProfileSwitcherManager";
import { MockedProvider } from "@apollo/client/testing/react";

const StoryComponent = () => {
    return (
        <MockedProvider mocks={[]}>
            <MockedProfileSwitcherManager>
                <VerificationFailed />
            </MockedProfileSwitcherManager>
        </MockedProvider>
    );
};

const meta = {
    title: "Screens/Verification Failed",
    component: StoryComponent,
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
